/*
 * @Author:
 * @LastEditTime: 2025-12-11 17:51:04
 * @Description: 后台管理
 */
export default [
  {
    id: '4eb49079-20b9-4b32-8cd3-d7676bf50de5',
    name: 'equipment-disassemble-training',
    path: '/equipment-disassemble-training',
    meta: { title: '设备拆解培训(5.0)' },
    layout: 'fullscreen',
    children: [
      {
        id: 'de23e891-260b-4871-bc4b-7351845b8fe0',
        path: 'list',
        name: 'list',
        component(resolve) {
          require(['./views/list'], resolve)
        },
        meta: {
          title: '拆解培训列表页',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            edit: {
              id: 1,
              name: 'edit',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: 'fa04db33-b16e-4972-96f8-0748aca00c31',
        path: 'modify-training',
        name: 'modify-training',
        component(resolve) {
          require(['./views/modifyTraining'], resolve)
        },
        meta: {
          title: '拆解培训模型',
          operations: {},
        },
      },
      {
        id: 'c8021f0f-da1a-4d0c-a0c1-0b531159d6fc',
        path: 'study-scheme',
        name: 'study-scheme',
        component(resolve) {
          require(['./views/studyScheme'], resolve)
        },
        meta: {
          title: '学习方案',
          operations: {},
        },
      },
    ],
  },
]
